import axios from 'axios';
const apiUrl = process.env.REACT_APP_API_CORE_URL;

// Get info about if user is in the municipality (latitude, longitude order )
export const ValidateIfLocationInAppName = (url, lat, lng) =>
	axios.get(`${apiUrl}/location/validate-location/${url}?q=${`${lat},${lng}`}`);

export const GetLonLatFromAppName = (url) =>
	axios.get(`${apiUrl}/location/reverse-geocoding/${url}`);

// Get metadata and schema for the form
export const GetFormSchema = (url) => () =>
	axios.get(`${apiUrl}/form/${url}/schema`);

// post input values to a baseUrl, add token if user exists
export const PostFormValues = (url, body, user = null) => {
	const headers = {};
	if (user && user.token !== null) {
		headers['Authorization'] = `basic ${user.token}`;
	}

	return axios.post(`${apiUrl}/form/${url}/schema`, body, {
		headers,
		withCredentials: true,
	});
};
